import { Content } from '@mainstage/core-components';
import { Box, Typography, useTheme } from '@material-ui/core';
import { Logo } from '../WbAppToolbar/Logo/Logo';
import Icon from './MaintenanceIllustration.svg';
import { WbPage } from '@agilelab/plugin-wb-platform';

export function MaintenancePage() {
  const theme = useTheme();
  return (
    <WbPage themeId="maintenance">
      <Content>
        <Box
          display="flex"
          flexDirection="column"
          height="100%"
          alignItems="center"
          justifyContent="center"
        >
          <Box
            style={{
              padding: theme.spacing(1),
              height: '100px',
            }}
          >
            <Logo />
          </Box>
          <Typography variant="h2">
            We are currently under maintenance!
          </Typography>
          <img src={Icon} alt="" />
          <Typography variant="body2">
            Apologies for the inconvenience...we will back soon.
          </Typography>
        </Box>
      </Content>
    </WbPage>
  );
}
